module.exports = __webpack_public_path__ + "static/img/originImg2.12c4943.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/originImg2.png
// module id = QEJt
// module chunks = 0